import React, { useCallback, useState } from "react";
import Pagination from "../../ui/Pagination";
import { useGetMoneyTransferReqs } from "../../lib/queries/queriesAndMutations";
import NewWithdrawCard from "../../shared/NewWithdrawCard";
import Loader from "../../shared/Loader";
import icons from "../../lib/icons";
import { useNavigate } from "react-router-dom";
import ConfirmMoneyTransfer from "../incomes/ConfirmMoneyTransfer";

const MoneyTransferReqList = ({ refetch }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20;
  const navigate = useNavigate();

  const onPageChange = useCallback((page) => {
    setCurrentPage(page);
  }, []);

  const {
    data: moneyTransferReqs,
    isPending,
    isRefetching,
  } = useGetMoneyTransferReqs({
    currentPage,
    pageSize,
  });

  const hasRequests = moneyTransferReqs?.data?.count > 0;

  if (isPending || isRefetching) {
    return (
      <div className="w-full h-full min-h-[400px] flex justify-center items-center">
        <Loader />
      </div>
    );
  }

  return (
    <>
      <div className="flex flex-col gap-2 items-center justify-center w-full max-h-full overflow-scroll no-scrollbar">
        <h2 className="text-dark text-[14px] font-bold mb-2">
          لیست انتقالات جاری
        </h2>

        {hasRequests ? (
          <div className="flex flex-col gap-1 w-full  ">
            {moneyTransferReqs.data.results.map((item) => (
              <NewWithdrawCard key={item.id} item={item} refetch={refetch} />
            ))}

            <div className="w-full rounded-v-lg mt-2">
              <Pagination
                onPageChange={onPageChange}
                totalCount={moneyTransferReqs?.data?.count || 0}
                siblingCount={1}
                currentPage={currentPage}
                pageSize={pageSize}
                className="bg-primary-40"
              />
            </div>

            <button
              onClick={(e) => navigate("/withdrawals/transfer")}
              className="py-3 px-4 bg-dark text-white w-fit mr-auto    h-full flex-center rounded-xl  text-[12px] md:text-[14px] font-semibold border-dark border-[0.75px] "
            >
              درخواست جدید{" "}
            </button>

            <div className="w-full bg-white flex mr-auto ">
              {hasRequests > 0 && (
                <ConfirmMoneyTransfer className=" transfer-btn  w-full mt-8 flex gap-2  ">
                  {isPending ? (
                    <p className="flex gap-1 ">
                      <div className="w-6 h-6">
                        <Loader />
                      </div>{" "}
                    </p>
                  ) : (
                    "ثبت نهایی درخواست ها"
                  )}
                  <img
                    src={icons.withdraw}
                    alt="info"
                    className="size-6 md:size-8 lg:size-10 invert"
                  />{" "}
                </ConfirmMoneyTransfer>
              )}
            </div>
          </div>
        ) : (
          <EmptyState />
        )}
      </div>
    </>
  );
};

const EmptyState = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center gap-2 w-full text-center">
      <img
        src={icons.sadEmoji}
        alt="No requests"
        className="w-8 h-8 md:w-12 md:h-12 lg:w-16 lg:h-16"
      />
      <p className="text-[12px] font-semibold">درخواستی وجود ندارد!</p>
      <p className="text-[12px] font-normal">
        برای انتقال وجه جدید دکمه زیر را کلیک نمایید:
      </p>
      <button
        onClick={(e) => navigate("/withdrawals/transfer")}
        className="py-3 px-4 bg-dark text-white   col-span-2  h-full flex-center rounded-xl  text-[12px] md:text-[14px] font-semibold border-dark border-[0.75px] "
      >
        درخواست جدید{" "}
      </button>
    </div>
  );
};

export default MoneyTransferReqList;
